<template>
    <div class="header-profile">
        <span class="header-profile__heading">Profil ve Ayarlar</span>
        <span class="header-profile__text">Profil bilgilerini ve ayarlarını değiştir.</span>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped src="@/css/components/header-profile.css"></style>